import React from 'react'
import { ProgressBarWrapper, ProgressBarFill, ProgressBarText } from './styles'
import { Box } from 'shared'

interface ProgressBarProps {
  visibleSlides: number
  totalSlides: number
  progressBarText?: string
}

export default function ProgressBar({ visibleSlides, totalSlides, progressBarText = 'Step' }: ProgressBarProps) {
  const progress = (visibleSlides / totalSlides) * 100

  return (
    <Box display="flex" flexDirection="column" alignItems="center">
      <ProgressBarWrapper>
        <ProgressBarFill fillPercentage={progress} />
      </ProgressBarWrapper>
      <ProgressBarText>
        {progressBarText} {visibleSlides} of {totalSlides}
      </ProgressBarText>
    </Box>
  )
}
